import React from 'react';
import { Routes, Route, useNavigate } from "react-router-dom";
import { toast } from 'sonner';
import UserList from './User';
import AddUser from './AddUser';
import EditUser from './EditUser';
import ViewUser from './ViewUser';

const ProtectedRoute = ({ element, permission, fallbackPath = '/dashboard/user' }) => {
  const navigate = useNavigate();

  React.useEffect(() => {
    if (!permission) {
      toast.warning("You don't have permission to access this page.");
      navigate(fallbackPath, { replace: true });
    }
  }, [permission, navigate, fallbackPath]);

  return permission ? element : null;
};

const MainUser = () => {
  const User = JSON.parse(localStorage.getItem("User") || "{}");
  const Permission = User?.userRole?.permissions?.system || {}; // Using 'system' permissions

  return (
    <div className='bg-gray-100 text-gray-900 dark:bg-gray-900 dark:text-white relative'>
      <Routes>
        <Route path='/' element={<UserList />}></Route>
        <Route
          path='/add-user'
          element={<ProtectedRoute element={<AddUser />} permission={Permission.create} />}
        />

        <Route
          path='/view-user'
          element={<ProtectedRoute element={<ViewUser />} permission={Permission.read} />}
        />

        <Route
          path='/edit-user'
          element={<ProtectedRoute element={<EditUser />} permission={Permission.update} />}
        />
      </Routes>
    </div>
  );
};

export default MainUser;
